import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppAuth } from '../components/AuthContext.jsx';
import { logout } from '../services/auth.js';

// Dashboard: the first authenticated screen. Shows the user's name and a
// couple of entry points. More feature screens will hang off /dashboard
// as Phase 3 lands.
export default function Dashboard() {
  const { user } = useAppAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);

  const isJr = user?.role === 'JR';
  const isJch = user?.role === 'JCH';
  const isMakler = user?.role === 'Makler';

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  if (!user) {
    return <div className="dashboard__status">Načítá se…</div>;
  }

  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <h1 className="dashboard__title">Vítejte{user.full_name ? `, ${user.full_name}` : ''}</h1>
        <button className="button button--quiet" onClick={handleLogout}>
          Odhlásit se
        </button>
      </div>

      {error && <p className="dashboard__error" role="alert">{error}</p>}

      <p className="dashboard__lead">
        {isJr
          ? 'Jste v roli JR. Sledujte makléře, rozdělujte úrovně a řídíte jejich výkon podle plánu.'
          : isJch
            ? 'Jste v roli JCH. Spravujete organizaci, KPI, reporty a administraci makléřů.'
            : 'Drill je nástroj pro podporu makléřů na jejich kariérní cestě do Rozjezdu.'}
      </p>

      <div className="dashboard__cards">
        <article className="card">
          <h3 className="card__title">Mé aktivity</h3>
          <p className="card__text">Zapište dnesní kontakty a schůzky. Pravidelný zápis je záklou všeho.</p>
          <Link className="button button--secondary" to="/dashboard/activities">Otevřít</Link>
        </article>

        <article className="card">
          <h3 className="card__title">Mé cíle</h3>
          <p className="card__text">Prohlédněte si týdenní cíle a semafor podle plánu.</p>
          <Link className="button button--secondary" to="/dashboard/goals">Otevřít</Link>
        </article>

        <article className="card">
          <h3 className="card__title">Moje cesta</h3>
          <p className="card__text">Vývojové úrovně, milníky a příští kroky na vaší cestě.</p>
          <Link className="button button--secondary" to="/dashboard/journey">Otevřít</Link>
        </article>

        {(isJr || isJch) && (
          <article className="card">
            <h3 className="card__title">Databáze makléřů</h3>
            <p className="card__text">Přehled makléřů, jejich úrovní, semaforu a aktuálního plánu.</p>
            <Link className="button button--secondary" to="/dashboard/database">Otevřít</Link>
          </article>
        )}

        {isJr && (
          <article className="card">
            <h3 className="card__title">Zařazení do úrovně</h3>
            <p className="card__text">Vytvořte úrovně, návrhy a audity pro jednotlivé makléře.</p>
            <Link className="button button--secondary" to="/dashboard/level-assignment">Otevřít</Link>
          </article>
        )}

        {isJch && (
          <>
            <article className="card">
              <h3 className="card__title">Účty a skupiny</h3>
              <p className="card__text">Správa uživatelů, rolí, stavů a týmové organizace.</p>
              <Link className="button button--secondary" to="/accounts">Otevřít</Link>
            </article>

            <article className="card">
              <h3 className="card__title">Společná čísla</h3>
              <p className="card__text">KPI, reporty a měření výkonu celé skupiny.</p>
              <Link className="button button--secondary" to="/dashboard/cisla">Otevřít</Link>
            </article>
          </>
        )}

        {!isMakler && !isJr && !isJch && (
          <article className="card">
            <h3 className="card__title">Role</h3>
            <p className="card__text">Nebyla rozpoznána role uživatele. Zkuste se znovu přihlásit.</p>
          </article>
        )}
      </div>
    </section>
  );
}
